// extracted by mini-css-extract-plugin
module.exports = {"loaderRing":"loader-ring_loaderRing__3Qelw"};